module.exports = __webpack_public_path__ + "ibas.png?5cea28f88673df10e3364266914b54aa";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ibas.png
// module id = 178
// module chunks = 0